<template>
  <div class="relative w-full rounded-xl border border-[#424242] overflow-hidden py-8 px-4 text-center">
    <!-- star effect background overlay -->
    <div
      class="absolute inset-0 opacity-50"
      style="background-image: url('/images/astrology/stars-background.png'); background-size: contain; background-position: center"
    ></div>

    <!-- content -->
    <div class="relative z-10">
      <h2 class="mb-4 text-20 sm:text-28 leading-24 sm:leading-36 font-bold text-white">
        {{ content.title }}
      </h2>

      <p class="mb-6 text-sm sm:text-xl font-medium leading-18 sm:leading-24 text-white">
        {{ horoscopeName }} {{ content.description }}
        <br />
        <span class="hidden sm:block">{{ content.subDescription }}</span>
      </p>

      <OButton pure :href="content.link" class="u-center mx-auto bg-white text-[#181819] text-lg font-medium px-8 py-4 rounded-full w-max">
        🔮 Şimdi Oku
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OButton } from '@/modules/common/components/ui';
import { getCtaDetails } from '@/modules/astrology/utils/astrologyUtils';
export default defineComponent({
  components: {
    OButton,
  },
  props: {
    horoscopeName: {
      type: String,
      required: true,
    },
    horoscope: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'general',
    },
    frequency: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const content = getCtaDetails(props.frequency, props.horoscope, props.type);
    return {
      content,
    };
  },
});
</script>
